type GetBeneficiaryNameArgs = {
  legalName?: string;
  firstName?: string;
  lastName?: string;
};

export const getBeneficiaryName = ({ legalName, firstName, lastName }: GetBeneficiaryNameArgs) => {
  if (legalName) {
    return legalName;
  }

  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  if (firstName) {
    return firstName;
  }

  return lastName ?? '';
};
